import React, { createContext, useContext, useState, ReactNode } from 'react';

type FormData = {
  [key: string]: any;
};

type FormDataContextType = {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  clearFormData: () => void;
};

const FormDataContext = createContext<FormDataContextType | undefined>(undefined);

export const FormDataProvider = ({ children }: { children: ReactNode }) => {
  const [formData, setFormData] = useState<FormData>({});

  const clearFormData = () => {
    setFormData({});
  };

  return (
    <FormDataContext.Provider value={{ formData, setFormData, clearFormData }}>
      {children}
    </FormDataContext.Provider>
  );
};

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (!context) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
};